import { AppPage } from '@launchpad';
import React from 'react';
import BreadcrumbHelper from '@launchpad/util/BreadcrumbHelper';
import { StipLogsTable } from '../../components';

const StipLogsList = (props) => {
  BreadcrumbHelper.setCrumbs([
    {
      label: 'STIP Logs',
    },
  ]);
  return (
    <AppPage title="STIP Log Records" icon="list">
      <StipLogsTable />
    </AppPage>
  );
};

export default StipLogsList;
